<template>
  <div class="sidebar">
    <header class="sidebar__header">
      <h2 class="sidebar__title">{{ $t(`${namespace}.title`) }}</h2>

      <router-link
        :to="{ name: 'Reports', params: { type: 'corridas' } }"
        :title="$t('Common.seeMore')"
        class="sidebar__header__action"
      >
        <span>{{ $t('Common.seeMore') }}</span>
        <v-icon>add</v-icon>
      </router-link>
    </header>

    <div>
      <RideList
        :data="{}"
        drawerType="home"
        :filters="filters"
        :scrollCalcDiff="54"
        @change="change"
      />
    </div>
  </div>
</template>

<script>
import RideList from 'components/GlobalDrawer/RideList'

export default {
  name: 'LatestRidesSidebar',
  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    RideList
  },
  data () {
    return {
      namespace: 'Components.LatestRidesSidebar'
    }
  },
  methods: {
    change (val) {
      if (val && val.data && val.data.id) {
        this.$emit('openRideDrawer', {
          taxiJobId: val.data.id
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  background-color: $white;
  border-left: 1px solid $gray-4;
  bottom: 0;
  position: fixed;
  right: 0;
  top: 128px;
  width: 360px;
}

.sidebar__header {
  border-bottom: 1px solid $gray-4;
  display: flex;
  height: 64px;
  padding: 0 16px;
  position: relative;
}

.sidebar__title {
  align-items: center;
  color: var(--gray-7);
  display: flex;
  font-family: $title-font;
  font-size: $base-font-size + 2px;
  font-weight: 700;
  line-height: normal;

  span {
    font-weight: 400;
  }
}

a.sidebar__header__action {
  color: $accent;
  font-size: $base-font-size - 1px;
  line-height: 1;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  text-decoration: none;

  @media (min-width: 768px) {
    font-size: 13px;
    right: 16px;
  }

  .v-icon {
    color: $accent;
    font-size: 14px;
  }

  span {

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
